import { v4 as uuidv4 } from 'uuid';
import { POINTS_SOURCE, POINTS_CIRCLE_LAYER, POINTS_SYMBOL_LAYER } from './constants';
import { LocationType } from '../Sidebar/LocationList';
import { safeSetSourceData } from './utils';

// Update location points data
export const updateLocations = ({
  map,
  mapReady,
  sourcesReady,
  locations,
  startId
}) => {
  if (!map || !mapReady || !sourcesReady) {
    return;
  }
  
  try {
    // Convert location data to GeoJSON format
    const pointFeatures = locations.map(location => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [location.longitude, location.latitude]
      },
      properties: {
        id: location.id,
        name: location.name,
        latitude: location.latitude,
        longitude: location.longitude,
        type: location.type || LocationType.NORMAL,
        isStart: location.id === startId
      }
    }));
    
    // Create GeoJSON data structure
    const data = {
      type: 'FeatureCollection',
      features: pointFeatures
    };
    
    // Check if source exists before updating
    if (!map.getSource(POINTS_SOURCE)) {
      console.error('[MapMarkers] POINTS_SOURCE not found on map!');
      return;
    }
    
    // Update points data source
    safeSetSourceData(map, mapReady, sourcesReady, POINTS_SOURCE, data);
    
  } catch (err) {
    console.error("[MapMarkers] Error updating location points data:", err);
  }
};

// Handle map click to add new point
export const handleMapClick = (e, {
  currentMode,
  setupSubmode,
  locations,
  setLocations
}) => {
  // Only allow adding points in "Setup Path Points" mode and "Map Point Marking" submode
  if (currentMode !== 'Setup Path Points' || setupSubmode !== 'Map Point Marking') return;
  
  const { lng, lat } = e.lngLat;
  
  // Generate unique ID
  const id = uuidv4();
  
  // Calculate next sequence number
  const nextNumber = locations.length + 1;
  const pointName = `${nextNumber}`;
  
  // Create new location point
  const newPoint = {
    id,
    name: pointName,
    latitude: lat,
    longitude: lng,
    type: LocationType.NORMAL
  };
  
  // Update locations list
  setLocations(prev => [...prev, newPoint]);
};

// Handle clicking existing marker point
export const handleSelectPoint = (params) => {
  const { 
    map, 
    pointId, 
    locations, 
    currentMode, 
    startId, 
    setStartId, 
    onMapPointSelect 
  } = params;

  // Skip if no point ID
  if (!pointId) {
    return;
  }
  
  // Handle start point selection in Setup mode
  if (currentMode === 'Setup Path Points' && setStartId) {

    setStartId(pointId);
    return;
  }
  
  // Handle point selection in Custom Path mode
  if (currentMode === 'Custom Path') {
    if (!onMapPointSelect) {
      console.error('[DEBUG-MAP] No point selection callback available in Custom Path mode');
      return;
    }
    
    // Double check callback type
    if (typeof onMapPointSelect !== 'function') {
      console.error(`[DEBUG-MAP] Invalid callback type: ${typeof onMapPointSelect}`);
      return;
    }
    
    // Find corresponding location point object
    const selectedPoint = locations.find(loc => loc.id === pointId);
    if (selectedPoint) {

      try {
        // Call callback function with the selected point

        onMapPointSelect(selectedPoint);

      } catch (error) {
        console.error('[DEBUG-MAP] Error calling point selection callback:', error);
      }
    } else {

    }
  }
};

// Set up marker hover events
export const setupMarkerHoverEvents = (map, popupRef) => {
  if (!map) return;
  
  // Only change cursor style when hovering over points
  map.on('mouseenter', POINTS_CIRCLE_LAYER, () => {
    map.getCanvas().style.cursor = 'pointer';
  });
  
  // Restore default cursor when mouse leaves point
  map.on('mouseleave', POINTS_CIRCLE_LAYER, () => {
    map.getCanvas().style.cursor = '';
  });
}; 